//export const API_URL = 'http://localhost:3000';

// export const API_URL = 'https://fiery-plate-429713-j6.oa.r.appspot.com'
export const API_URL ='https://bauapi.bengibert.com'

export const PROJECT_TYPES = [
    'LOGEMENTS INDIVIDUELS',
    'LOGEMENTS COLLECTIFS',
    'RÉSIDENCES DE TOURISME',
    'ÉQUIPEMENTS TECHNIQUES',
    'ÉTABLISSEMENTS SCOLAIRES',
    'ÉTABLISSEMENTS DE SANTÉ',
    'ÉQUIPEMENTS CULTURELS ET SPORTIFS',
    'BUREAUX ET LOCAUX ASSOCIATIFS',
    'URBANISME ET TERRITOIRE',
    'PROGRAMME MIXTE',
    'CONCOURS',
    'DIVERS',
];

// Textes du hero affichés tant qu'aucun texte n'a été saisi dans le backoffice.
export const DEFAULT_HERO_TITLE = 'Une architecture sur mesure, attentive aux lieux et aux usages.';
export const DEFAULT_HERO_DESCRIPTION = 'J’accompagne les particuliers, les entreprises et les collectivités sur une ou plusieurs étapes de leurs projets de rénovation, d’extension, de construction neuve, d’aménagement intérieur ou d’études urbaines. À Saint-Étienne, dans la Loire et la région lyonnaise.';
// Textes de la section « Approche » affichés tant qu'aucun texte n'a été saisi dans le backoffice.
export const DEFAULT_APPROACH_TITLE = 'Une démarche attentive aux lieux et aux usages';
export const DEFAULT_APPROACH_ITEMS = [
    {
        title: 'Une expérience plurielle',
        text: '8 ans en agences, puis une pratique indépendante, sur des projets publics et privés de différentes échelles.',
    },
    {
        title: 'Observer avant de proposer',
        text: 'Lire le lieu, ses usages et ses contraintes avant de définir les pistes d’intervention.',
    },
    {
        title: 'Réhabiliter le déjà-là',
        text: 'Révéler les qualités et le caractère du patrimoine ordinaire en accompagnant sa transformation.',
    },
    {
        title: 'Des choix sobres et précis',
        text: 'Réemploi, ressources locales et savoir-faire nourrissent une approche frugale et attentive aux coûts.',
    },
    {
        title: 'Une mission ajustée',
        text: 'Une ou plusieurs étapes, définies ensemble selon vos besoins et votre budget.',
    },
    {
        title: 'Une interlocutrice, un réseau local',
        text: 'Je coordonne les échanges avec les bureaux d’études et les artisans mobilisés selon les besoins du projet.',
    },
];

// Phrase d'accroche au-dessus des étapes du processus, affichée tant qu'aucune n'a été saisie dans le backoffice.
export const DEFAULT_PROCESS_TITLE = 'Mes prestations : un service adapté à chaque besoin';

// Petits descriptifs sous les pictogrammes de la page d'accueil, affichés tant qu'aucun n'a été saisi dans le backoffice.
export const DEFAULT_MISSION_DESCRIPTIONS = {
    construction: "Concevoir un bâtiment neuf, de l'esquisse au suivi de chantier.",
    renovation: "Transformer l'existant en révélant ses qualités et son caractère.",
    extension: "Agrandir ou surélever avec justesse, en dialogue avec le bâti d'origine.",
    amenagements: "Repenser les espaces intérieurs selon vos usages et votre budget.",
};

// Textes détaillés des quatre étapes (dans l'ordre : Conseiller, Concevoir, Préparer, Construire),
// affichés sous le résumé de l'étape tant qu'aucun texte n'a été saisi dans le backoffice.
export const DEFAULT_PROCESS_DETAILS = [
    "<p>Visite du site et échanges sur vos besoins, vos envies et votre budget. Je recense les contraintes réglementaires, techniques et de calendrier pour définir avec vous le périmètre de ma mission et les premières orientations du projet.</p>",
    "<p>Relevé de l'existant, analyse du bâti, du terrain et du contexte réglementaire. Ce diagnostic révèle le potentiel du lieu, signale les points de vigilance et débouche sur des pistes d'intervention chiffrées, avant tout engagement.</p>",
    "<p>Esquisses, plans, volumes et choix des matériaux : le projet prend forme avec vous. Je constitue les dossiers d'autorisation, puis prépare la consultation des entreprises (pièces écrites, plans d'exécution, analyse des offres).</p>",
    "<p>Réunions de chantier régulières, contrôle de la qualité d'exécution, respect des délais et du budget. Je reste votre interlocutrice auprès des entreprises, jusqu'à la réception des travaux et la levée des réserves.</p>",
];
